import SocialMediaIcons from "../components/SocialMediaIcons";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-gray-900 via-gray-800 to-gray-700 text-white py-10">
      <div className="w-10/12 mx-auto space-y-8">
        {/* Social Media Icons */}
        <div className="flex justify-center">
          <SocialMediaIcons />
        </div>

        {/* Footer Content */}
        <div className="md:flex justify-between items-start text-center md:text-left space-y-8 md:space-y-0">
          {/* Branding Section */}
          <div className="md:w-1/3">
            <p className="font-playfair font-bold text-2xl">MBT Solutions</p>
            <p className="text-gray-400 text-sm mt-2 leading-relaxed">
              Empowering businesses with cutting-edge templates and AI solutions to streamline workflows and achieve growth.
            </p>
          </div>

          {/* Navigation Links */}
          <div className="flex flex-col space-y-3 md:w-1/3 md:items-center">
            <a
              href="#home"
              className="hover:text-yellow transition duration-300 text-sm"
            >
              Home
            </a>
            <a
              href="#services"
              className="hover:text-yellow transition duration-300 text-sm"
            >
              Services
            </a>
            <a
              href="#products"
              className="hover:text-yellow transition duration-300 text-sm"
            >
              Products
            </a>
            <a
              href="#contact"
              className="hover:text-yellow transition duration-300 text-sm"
            >
              Contact
            </a>
          </div>

          {/* Copyright Section */}
          <div className="md:w-1/3">
            <p className="text-gray-400 text-xs">
              © {new Date().getFullYear()} MBT Solutions. All Rights Reserved.
            </p>
            <p className="text-gray-400 text-xs mt-1">
              Designed and developed with precision.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
